import React, { FC } from 'react';
import { Checkbox, Form } from 'antd';

// Styles
import './country-filter.scss';

// Models
import { ICountry } from '../../../../interfaces/core.interfaces';

type TCountryFilterProps = {
  countries: ICountry[];
}

export const CountryFilter: FC<TCountryFilterProps> = (
  { countries }: TCountryFilterProps
) => {

  const options = countries.map(({ name, code }) => ({ value: code, label: name }));

  return (
    <div className="country-filter">
      <Form.Item name={ 'countries' }>
        <Checkbox.Group options={ options }/>
      </Form.Item>
    </div>
  );
}
